<ng-template #Modal let-data let-ref="modalRef">
  <nb-card *ngIf="orderDetail" class="staffInfoTemplate" style="max-width: 800px">
    <nb-card-header style="display: flex; justify-content: space-between; align-items: center;">
      <span>{{ tt('common_view', '查看') }}{{ tt('report_order_record', '訂單紀錄') }}</span>
      <button nbButton (click)="AdjustTransactionMo.onOpen(orderDetail)" *ngIf="ORD_Status_ID != 3">
        {{ tt('report_adjust_transaction', '調整交易') }}
      </button>
    </nb-card-header>

    <nb-card-body>
      <div class="row">
        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_order_number', '訂單編號') }}</label>
          <h6>{{ orderDetail.ORDNo }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_pickup_number', '取餐號碼') }}</label>
          <h6>{{ displayText(orderDetail.PickupNumber) }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORDSerialNumber != null">
          <label class="label col-sm-12 col-form-label">{{ tt('report_online_order_number', '線上訂單號碼') }}</label>
          <h6>{{ orderDetail.ORDSerialNumber }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_order_time', '訂單時間') }}</label>
          <h6>{{ orderDetail.CreateDate }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_dining_type', '用餐類型') }}</label>
          <h6>{{ getOrderKindLabel(orderDetail.ORD_Kind_ID) }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_order_status', '訂單狀態') }}</label>
          <h6>{{ displayText(orderDetail.ORDStatusName) }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_full_name', '姓名') }}</label>
          <h6>{{ displayText(orderDetail.Name) }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_customer_phone', '客戶電話') }}</label>
          <h6>{{ displayText(orderDetail.Phone) }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID != 3">
          <label class="label col-sm-12 col-form-label">{{ getMealTimeLabel(orderDetail.ORD_Kind_ID) }}</label>
          <h6>{{ displayText(orderDetail.MealTime) }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID == 2">
          <label class="label col-sm-12 col-form-label">{{ tt('common_delivery_address', '外送地址') }}</label>
          <h6>{{ displayText(orderDetail.Address) }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID == 3">
          <label class="label col-sm-12 col-form-label">{{ tt('common_table', '桌號') }}</label>
          <h6>{{ displayText(orderDetail.TableName) }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID == 3">
          <label class="label col-sm-12 col-form-label">{{ tt('report_customers', '內用人數') }} ({{ tt('common_adults', '大人') }} | {{ tt('common_children', '小孩') }})</label>
          <h6>{{ orderDetail.Adults }} | {{ orderDetail.Children }}</h6>
        </div>

        <div class="col-sm-12 xd" *ngIf="orderDetail.CancelReason != null && orderDetail.InvoiceNumber == null">
          <label class="label col-sm-12 col-form-label">{{ tt('report_void_reason', '作廢原因') }}</label>
          <h6>{{ displayText(orderDetail.CancelReason) }}</h6>
        </div>

        <div class="col-sm-12 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_remark', '備註') }}</label>
          <h6>{{ displayText(orderDetail.Note) }}</h6>
        </div>

        <div class="col-sm-12 xd" *ngIf="orderDetail.EmployeeName">
          <label class="label col-sm-12 col-form-label">{{ tt('report_checkout_staff', '結帳人員') }}</label>
          <h6>{{ displayText(orderDetail.EmployeeName) }}</h6>
        </div>
      </div>

      <div class="row">
        <div class="titleHr">
          <span>{{ tt('common_payment_info', '付款資訊') }}</span>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_payment_status', '付款狀態') }}</label>
          <h6>{{ displayText(orderDetail.PayStatusName) }}</h6>
        </div>

        <ng-container *ngFor="let e of orderDetail.PaymentKindData">
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">
              {{ e.PaymentKindName }} : {{ tt('report_received_cash', '收款') }} | {{ tt('report_change_cash', '找零') }}
            </label>
            <h6>{{ e.ReceivedCash | currency : null : true : '1.0' }} | {{ e.ChangeCash | currency : null : true : '1.0' }}</h6>
          </div>
        </ng-container>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_order_amount', '訂單金額') }}</label>
          <h6>{{ orderDetail.Cash | currency : null : true : '1.0' }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_discount_amount', '折扣金額') }}</label>
          <h6>{{ orderDetail.DiscountCash | currency : null : true : '1.0' }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_service_charge', '服務費') }}</label>
          <h6>{{ orderDetail.ServiceFee | currency : null : true : '1.0' }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_shipping_fee', '運費') }}</label>
          <h6>{{ orderDetail.ShippingFee | currency : null : true : '1.0' }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_total', '總計') }}</label>
          <h6>{{ orderDetail.TotalCash | currency : null : true : '1.0' }}</h6>
        </div>
      </div>

      <div class="row" *ngIf="orderDetail.IsOnlinePamentData == 1">
        <div class="titleHr">
          <span>{{ tt('common_online_payment', '線上付款資訊') }}</span>
        </div>

        <ng-container *ngFor="let e of orderDetail.PaymentKindData">
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">{{ e.PaymentKindName }}</label>
            <h6 *ngIf="e.transactionId == null">{{ tt('report_online_payment_no_transaction', '尚無交易資料') }}</h6>
            <h6 *ngIf="e.transactionId != null">{{ tt('report_transaction_id', '交易序號') }}: {{ e.transactionId }}</h6>
            <h6 *ngIf="e.CheckoutDateTimeString != null">{{ tt('report_checkout_date', '結帳時間') }}: {{ e.CheckoutDateTimeString }}</h6>
            <h6 *ngIf="e.CancelDateTimeString != null">{{ tt('report_void_time', '作廢時間') }}: {{ e.CancelDateTimeString }}</h6>
          </div>
        </ng-container>
      </div>

      <div class="row" *ngIf="orderDetail.NCCCData != null">
        <div class="titleHr">
          <span>{{ tt('common_credit_card_info', '信用卡資訊') }}</span>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_merchant_id', '特店代號') }}</label>
          <h6>{{ orderDetail.NCCCData.MerchantID }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_terminal_id', '端末機代號') }}</label>
          <h6>{{ orderDetail.NCCCData.TerminalID }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_card_type', '卡別') }}</label>
          <h6>{{ orderDetail.NCCCData.CardType }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_card_number', '卡號') }}</label>
          <h6>{{ orderDetail.NCCCData.CardNo }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('common_time', '時間') }}</label>
          <h6>{{ orderDetail.NCCCData.CreateDate }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_approval_number', '授權碼') }}</label>
          <h6>{{ orderDetail.NCCCData.ApprovalNo }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_receipt_number', '簽單編號') }}</label>
          <h6>{{ orderDetail.NCCCData.ReceiptNo }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_batch_number', '批次編號') }}</label>
          <h6>{{ orderDetail.NCCCData.BatchNo }}</h6>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_credit_card_amount', '刷卡金額') }}</label>
          <h6>{{ orderDetail.NCCCData.TransAmount }}</h6>
        </div>
      </div>

      <div class="row">
        <div class="titleHr">
          <span>{{ tt('common_invoice_info', '發票資訊') }}</span>
        </div>

        <div class="col-sm-6 xd">
          <label class="label col-sm-12 col-form-label">{{ tt('report_invoice_status', '發票狀態') }}</label>
          <h6>{{ displayText(orderDetail.InvStatusName) }}</h6>
        </div>

        <ng-container *ngIf="hasInvoiceDetails()">
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">{{ tt('report_invoice_number', '發票號碼') }}</label>
            <h6>{{ displayText(orderDetail.InvoiceNumber) }}</h6>
          </div>

          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">{{ tt('report_invoice_pos', '開立 POS') }}</label>
            <h6>{{ displayText(orderDetail.POSName) }}</h6>
          </div>

          <div class="col-sm-6 xd" *ngIf="orderDetail.VoidReason">
            <label class="label col-sm-12 col-form-label">{{ tt('report_void_reason', '作廢原因') }}</label>
            <h6>{{ orderDetail.VoidReason }}</h6>
          </div>

          <div class="col-sm-6 xd" *ngIf="orderDetail.VoidTime">
            <label class="label col-sm-12 col-form-label">{{ tt('report_void_time', '作廢時間') }}</label>
            <h6>{{ orderDetail.VoidTime }}</h6>
          </div>

          <div class="col-sm-6 xd" *ngIf="orderDetail.TaxSaleAmount">
            <label class="label col-sm-12 col-form-label">{{ tt('report_taxable_sales', '應稅銷售額') }}</label>
            <h6>{{ orderDetail.TaxSaleAmount | currency : null : true : '1.0' }}</h6>
          </div>

          <div class="col-sm-6 xd" *ngIf="orderDetail.TaxFreeSaleAmount">
            <label class="label col-sm-12 col-form-label">{{ tt('report_tax_free_sales', '免稅銷售額') }}</label>
            <h6>{{ orderDetail.TaxFreeSaleAmount | currency : null : true : '1.0' }}</h6>
          </div>

          <div class="col-sm-6 xd" *ngIf="orderDetail.TaxZeroSaleAmount">
            <label class="label col-sm-12 col-form-label">{{ tt('report_zero_tax_sales', '零稅率銷售額') }}</label>
            <h6>{{ orderDetail.TaxZeroSaleAmount | currency : null : true : '1.0' }}</h6>
          </div>

          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">{{ tt('report_tax_amount', '稅額') }}</label>
            <h6>{{ orderDetail.TaxAmount | currency : null : true : '1.0' }}</h6>
          </div>
        </ng-container>

        <div class="col-sm-6 xd" *ngIf="orderDetail.BarCode">
          <label class="label col-sm-12 col-form-label">{{ getInvoiceCarrierLabel(orderDetail.INV_InvoiceKind_ID) }}</label>
          <h6>{{ orderDetail.BarCode }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.TaxID">
          <label class="label col-sm-12 col-form-label">{{ tt('common_tax_id', '統一編號') }}</label>
          <h6>{{ orderDetail.TaxID }}</h6>
        </div>

        <div class="col-sm-6 xd" *ngIf="orderDetail.InvCompanyName">
          <label class="label col-sm-12 col-form-label">{{ tt('report_invoice_company_name', '公司抬頭') }}</label>
          <h6>{{ orderDetail.InvCompanyName }}</h6>
        </div>
      </div>

      <div class="row">
        <div class="titleHr">
          <span>{{ tt('common_product_detail', '商品明細') }}</span>
        </div>

        <div class="col-xs-12">
          <div class="mx-0 px-2 row" *ngFor="let pd of orderDetail.OrderProductList; let index = index">
            <div class="img-box" style="width: 200px; height: 200px;">
              <img [src]="pd.Image">
            </div>

            <div class="col-sm">
              <label class="label col-sm-12 col-form-label text-info">{{ pd.ProductName }} x {{ pd.Quantity }}</label>
              <label class="label col-sm-12 col-form-label text-org">
                <span class="mr-3">{{ tt('common_price', '價格') }}: {{ pd.ProductCash | currency : null : true : '1.0' }}</span>
                <span class="mr-3 text-hint">{{ tt('report_discount_amount', '折扣金額') }}: {{ pd.TotalDiscountCash | currency : null : true : '1.0' }}</span>
                <span class="mr-3">{{ tt('common_total', '總計') }}: {{ pd.ProductTotalCash | currency : null : true : '1.0' }}</span>
              </label>
              <div class="label col-sm-12 col-form-label" style="margin-left: -10px;">
                <ng-container
                  *ngIf="pd"
                  [ngTemplateOutlet]="DeepShow"
                  [ngTemplateOutletContext]="{ $implicit: pd }">
                </ng-container>
              </div>
              <label class="label col-sm-12 col-form-label text-danger">{{ pd.Note }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="orderDetail.DiscountData && orderDetail.DiscountData.length">
        <div class="titleHr">
          <span>{{ tt('common_discount_detail', '折扣明細') }}</span>
        </div>
        <div class="col-12 d-flex justify-content-between" *ngFor="let item of orderDetail.DiscountData">
          <b>{{ item.DiscountName }}</b><b class="text-org">${{ item.TotalDiscountCash }}</b>
        </div>
      </div>

      <div class="row">
        <div class="titleHr">
          <span>{{ tt('common_adjust_account', '帳款調整紀錄') }}</span>
        </div>

        <div class="col-lg-12 m-0 p-0 overflow-x">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>{{ tt('common_time', '時間') }}</th>
                <th>{{ tt('common_operator', '操作人') }}</th>
                <th>{{ tt('common_payment_method', '付款方式') }}</th>
                <th>{{ tt('common_amount', '金額') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of adjustAccountList; let index = index">
                <td style="vertical-align: middle;">
                  {{ item.CreateDate }}
                </td>
                <td style="vertical-align: middle;">
                  {{ item.CreateBy }}
                </td>
                <td style="vertical-align: middle;">
                  {{ item.PaymentKindName }}
                </td>
                <td style="vertical-align: middle;">
                  {{ item.OriginalCash }}
                  <i class="fas fa-arrow-right" aria-hidden="true"></i>
                  {{ item.Cash }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </nb-card-body>

    <nb-card-footer>
      <div>
        <button nbButton (click)="onClose()">{{ tt('common_close', '關閉') }}</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #DeepShow let-pd>
  <div style="padding-left: 10px;" *ngFor="let a of pd.AttachItemList">
    + {{ a.AttachItemName }}
    <span *ngIf="a.AttachItemCash" class="text-org">{{ a.AttachItemCash | currency : null : true : '1.0' }}</span>
    <span *ngIf="a.AttachItemQuantity">x {{ a.AttachItemQuantity }}</span>
  </div>
  <div style="padding-left: 10px;" *ngFor="let pp of pd.PdList">
    + {{ pp.ProductName }}
    <span *ngIf="pp.ProductCash" class="text-org">{{ pp.ProductCash | currency : null : true : '1.0' }}</span>
    <span *ngIf="pp.Quantity">x {{ pp.Quantity }}</span>
    <div>
      <ng-container
        *ngIf="pp"
        [ngTemplateOutlet]="DeepShow"
        [ngTemplateOutletContext]="{ $implicit: pp }">
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #AdjustTransactionMoDOM let-data let-ref="dialogRef">
  <form #AdjustTransactionMoF="ngForm">
    <nb-card class="staffInfoTemplate">
      <nb-card-header>
        {{ tt('report_adjust_transaction', '調整交易') }}
      </nb-card-header>

      <nb-card-body>
        <div class="row mb-2" *ngFor="let item of AdjustTransactionMo.data.List; let i = index">
          <div class="row mx-0 col-lg-12">
            <label class="label col-sm-12 col-form-label">{{ item.Name }}</label>
            <p class="col-sm-12 col-form-label">
              {{ item.Cash }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="titleHr">
            <span>{{ tt('common_payment_method', '付款方式') }}{{ tt('common_adjust', '調整') }}</span>
          </div>
        </div>

        <div class="row rowTop" *ngFor="let adjust of AdjustTransactionMo.adjustList; let i = index">
          <div class="row mx-0 col-sm-6">
            <nb-select fullWidth [(ngModel)]="adjust.paymentKindId" name="paymentKind{{i}}">
              <nb-option *ngFor="let method of AdjustTransactionMo.paymentList" [value]="method.value">
                {{ method.content }}
              </nb-option>
            </nb-select>
          </div>
          <div class="row mx-0 col-sm-6">
            <input nbInput type="number" [(ngModel)]="adjust.amount" name="amount{{i}}" />
          </div>
          <div class="row mx-0 col-sm-12">
            <button nbButton fullWidth (click)="AdjustTransactionMo.removePayment(i)" type="button">
              {{ tt('common_remove', '移除') }}
            </button>
          </div>
        </div>
      </nb-card-body>

      <button nbButton class="m-0 col-12" (click)="AdjustTransactionMo.addPayment()" type="button">
        {{ tt('common_add', '新增') }}{{ tt('common_payment_method', '付款方式') }}
      </button>

      <nb-card-footer>
        <button nbButton (click)="AdjustTransactionMo.onSave()" type="button">{{ tt('common_confirm', '確認') }}</button>
        <button nbButton (click)="ref.close()" type="button">{{ tt('common_close', '關閉') }}</button>
      </nb-card-footer>
    </nb-card>
  </form>
</ng-template>
